import React, { useEffect, useState } from 'react';

import FormTitle from 'components/shared/Typography/FormTitle';

import Button from './Button';
import { NEW_LOGO_TITLE, SHOW_LOGO_TITTLE } from './constants';
import Editor from './Editor';
import Uploader from './Uploader';

const Logo = ({ active, currentLogo, onSave, onDelete }) => {
  const [file, setFile] = useState(null);
  const [logo, setLogo] = useState(null);

  const saveLogo = () => {
    const fileParams = Array.isArray(file) ? file[0] : file;
    onSave(fileParams || logo);
  };

  const replaceLogo = () => {
    setFile(null);
    setLogo(null);
  };

  const deleteLogo = () => {
    onDelete();
    setFile(null);
  };

  useEffect(() => {
    setFile(null);
  }, [active]);

  useEffect(() => {
    setLogo(currentLogo);
  }, [active, currentLogo]);

  return (
    <>
      <FormTitle center>{logo ? SHOW_LOGO_TITTLE : NEW_LOGO_TITLE}</FormTitle>

      {!file && !logo ? (
        <Uploader onUpload={setFile} />
      ) : (
        <Editor data={logo || file} onSave={saveLogo} onDelete={deleteLogo} onReplace={replaceLogo} />
      )}
    </>
  );
};

export { Button };

export default Logo;
